import { itemPages } from '../../../config/constantLists'
const DashboardLayout = () => import('../../../layouts/DashboardLayout.vue')
const Cities = () => import('./views/Cities')
const CityView = () => import('./views/CityView')

export default [
  {
    path: '/cities',
    component: DashboardLayout,
    meta: { auth: true },
    children: [
      {
        path: '',
        name: 'generalSettings.cities',
        meta: { auth: true },
        component: Cities
      },
      {
        path: 'view/:id?',
        name: 'generalSettings.cityView',
        meta: { auth: true, currentPage: itemPages.view },
        component: CityView,
        props: true
      },
      {
        path: 'create',
        name: 'generalSettings.cityCreate',
        meta: { auth: true, currentPage: itemPages.create },
        component: CityView
      },
      {
        path: 'update/:id?',
        name: 'generalSettings.cityUpdate',
        meta: { auth: true, currentPage: itemPages.update },
        component: CityView,
        props: true
      }
    ]
  }
]
